import {
  Braces,
  Container,
  Cpu,
  FileText,
  GraduationCap,
  Home,
  Mail,
  Server,
  SquareTerminal,
  User,
} from "lucide-react";
import ReadmeWindow from "@/components/windows/ReadmeWindow";
import Terminal from "@/components/terminal/Terminal";
import AboutWindow from "@/components/windows/AboutWindow";
import ExperienceWindow from "@/components/windows/ExperienceWindow";
import SkillsWindow from "@/components/windows/SkillsWindow";
import EducationWindow from "@/components/windows/EducationWindow";
import DevEnvWindow from "@/components/windows/DevEnvWindow";
import ContactWindow from "@/components/windows/ContactWindow";
import ResumeWindow from "@/components/windows/ResumeWindow";

export const APPS = [
  {
    id: "readme",
    title: "~/hello — Anish Ravi",
    component: ReadmeWindow,
    icon: Home,
    tile: "from-sky-400 to-blue-700",
    size: { w: 820, h: 700 },
    pos: { x: 210, y: 56 },
    inDock: true,
    dockLabel: "Home",
  },
  {
    id: "terminal",
    title: "zsh — anish@portfolio",
    component: Terminal,
    icon: SquareTerminal,
    tile: "from-slate-600 to-slate-900",
    size: { w: 740, h: 480 },
    pos: { x: 430, y: 120 },
    inDock: true,
    dockLabel: "Terminal",
  },
  {
    id: "about",
    title: "about.txt — Anish Ravi",
    component: AboutWindow,
    icon: User,
    tile: "from-blue-500 to-indigo-700",
    size: { w: 740, h: 640 },
    pos: { x: 170, y: 90 },
    inDock: true,
    dockLabel: "About",
  },
  {
    id: "experience",
    title: "experience.log — Anish Ravi",
    component: ExperienceWindow,
    icon: Server,
    tile: "from-cyan-500 to-blue-700",
    size: { w: 820, h: 660 },
    pos: { x: 280, y: 70 },
    inDock: true,
    dockLabel: "Experience",
  },
  {
    id: "skills",
    title: "skills.tree — Anish Ravi",
    component: SkillsWindow,
    icon: Braces,
    tile: "from-violet-500 to-purple-800",
    size: { w: 780, h: 620 },
    pos: { x: 320, y: 90 },
    inDock: true,
    dockLabel: "Skills",
  },
  {
    id: "education",
    title: "education.md — Anish Ravi",
    component: EducationWindow,
    icon: GraduationCap,
    tile: "from-sky-500 to-teal-600",
    size: { w: 700, h: 520 },
    pos: { x: 360, y: 110 },
    inDock: true,
    dockLabel: "Education",
  },
  {
    id: "devenv",
    title: "neofetch — dev environment",
    component: DevEnvWindow,
    icon: Cpu,
    tile: "from-amber-500 to-orange-700",
    size: { w: 780, h: 620 },
    pos: { x: 240, y: 100 },
    inDock: true,
    dockLabel: "Dev Env",
  },
  {
    id: "contact",
    title: "contact.sh — Anish Ravi",
    component: ContactWindow,
    icon: Mail,
    tile: "from-green-500 to-emerald-700",
    size: { w: 720, h: 580 },
    pos: { x: 380, y: 120 },
    inDock: true,
    dockLabel: "Contact",
  },
  {
    id: "resume",
    title: "AnishResume_WA.pdf",
    component: ResumeWindow,
    icon: FileText,
    tile: "from-rose-500 to-red-700",
    size: { w: 800, h: 680 },
    pos: { x: 300, y: 80 },
    inDock: true,
    dockLabel: "Resume",
  },
];
